/* swt-header-drawer.js · SWT Header v2 mobile menu (Concept-style).
   Bottom sheet slides up; links slide in from the left one after another;
   sub-menus slide in from the right with a back row; drag the handle down
   to close; focus stays inside while open; Esc closes (via swt-header.js);
   v2.6: the sheet opens in the browser top layer (popover="manual"), so app
   widgets (chat "Help" button, badges) stay where they are but sit under
   the menu. Browsers without popover fall back to a max z-index and the
   old hide-the-widgets pass. Logo / card images in a sub-view load only
   when that sub-view first opens (data-src); a card with no image takes
   the top best-seller's photo from the swt-mega-products feed.
   v2.7: "Best sellers" rows ([data-top-feed], e.g. under Accessories). The
   feed is fetched once, when the sheet first opens (HTML only; kept 10
   minutes in sessionStorage). The cards and their images appear when that
   sub-view opens. A failed fetch is retried once after 1.5s; if it fails
   again, or nothing is in stock, the row hides and the list still works.
   Registers on window.SWTHeaderModules, run by swt-header.js. */
(function () {
  'use strict';
  var mods = window.SWTHeaderModules = window.SWTHeaderModules || [];

  mods.push(function (ctx) {
    var section = ctx.section, doc = ctx.doc, sig = ctx.sig;
    var drawer = section.querySelector('[data-swt-drawer]');
    if (!drawer) return;
    var openBtn = ctx.root.querySelector('[data-swt-drawer-open]');
    var sheet = drawer.querySelector('[data-swt-sheet]');
    var grab = drawer.querySelector('[data-swt-grab]');
    var rootView = drawer.querySelector('[data-swt-view="root"]');
    var views = Array.prototype.slice.call(drawer.querySelectorAll('[data-swt-view]'));
    var tops = Array.prototype.slice.call(drawer.querySelectorAll('[data-top-feed]'));
    var current = rootView, hideT = 0, settleT = 0, lastFocus = null;
    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    /* top layer: puts the whole sheet above every z-index on the page */
    var usePop = drawer.hasAttribute('popover') && typeof drawer.showPopover === 'function';
    if (!usePop) drawer.classList.add('is-top');

    /* images in a sub-view load the first time it opens */
    function showImg(img, src, srcset) {
      img.addEventListener('load', function () { img.classList.add('is-in'); }, { once: true });
      if (srcset) img.srcset = srcset;
      img.src = src;
      if (img.complete && img.naturalWidth) img.classList.add('is-in');
    }
    /* the feed's src is a fixed size: ask the CDN for the sizes we need */
    function sized(src, w) {
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function feedUrl(handle) {
      return shopRoot + 'collections/' + encodeURIComponent(handle) + '?sort_by=best-selling&section_id=swt-mega-products';
    }
    function fillFromFeed(card) {
      var handle = card.getAttribute('data-feed');
      card.removeAttribute('data-feed');
      fetch(feedUrl(handle), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var pic = new DOMParser().parseFromString(html, 'text/html').querySelector('.swt-bm__card img');
          var src = pic && (pic.getAttribute('src') || pic.getAttribute('data-src'));
          if (!src) return;
          var img = doc.createElement('img');
          img.className = 'swt-dcard__img';
          img.alt = '';
          img.decoding = 'async';
          img.sizes = '(min-width: 750px) 230px, 50vw';
          card.insertBefore(img, card.firstChild);
          showImg(img, sized(src, 400), sized(src, 200) + ' 200w, ' + sized(src, 400) + ' 400w, ' + sized(src, 600) + ' 600w');
        })
        .catch(function () {});
    }

    /* ---------- v2.7 best sellers ---------- */
    var TOP_TTL = 600000, TOP_RETRY = 1500;
    function topKey(handle) {
      var S = window.Shopify || {};
      return 'swt-dtop-v1:' + (S.country || '') + '-' + ((S.currency && S.currency.active) || '') + ':' + handle;
    }
    function topParse(html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      if (!d.querySelector('.swt-bm__feed')) throw new Error('no feed');
      return Array.prototype.map.call(d.querySelectorAll('.swt-bm__card'), function (c) {
        var img = c.querySelector('img'), nm = c.querySelector('.swt-bm__name'), pr = c.querySelector('.swt-bm__price');
        return {
          h: c.getAttribute('href') || '#',
          s: img ? (img.getAttribute('src') || img.getAttribute('data-swt-src') || img.getAttribute('data-bm-src') || '') : '',
          a: img ? (img.getAttribute('alt') || '') : '',
          n: nm ? nm.textContent.trim() : '',
          p: pr ? pr.innerHTML.trim() : ''
        };
      });
    }
    function topGet(url) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(topParse);
    }
    function topLoad(box) {
      if (box._swtTop) return box._swtTop;
      var handle = box.getAttribute('data-top-feed'), k = topKey(handle);
      try {
        var o = JSON.parse(sessionStorage.getItem(k) || 'null');
        if (o && o.d && Date.now() - o.t < TOP_TTL) return (box._swtTop = Promise.resolve(o.d));
      } catch (e) {}
      var url = feedUrl(handle);
      var p = topGet(url)
        .catch(function () {
          return new Promise(function (res) { setTimeout(res, TOP_RETRY); }).then(function () { return topGet(url); });
        })
        .then(function (d) {
          try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
          return d;
        });
      box._swtTop = p;
      p.catch(function () { if (box._swtTop === p) box._swtTop = null; });
      return p;
    }
    function topCard(p, i) {
      var a = doc.createElement('a');
      a.className = 'swt-dprod is-new';
      a.href = p.h;
      a.style.setProperty('--k', i);
      var box = doc.createElement('span');
      box.className = 'swt-dprod__img';
      if (p.s) {
        var img = doc.createElement('img');
        img.alt = p.a;
        img.decoding = 'async';
        img.width = 400;
        img.height = 400;
        img.sizes = '(min-width: 750px) 210px, 44vw';
        box.appendChild(img);
        showImg(img, sized(p.s, 400), sized(p.s, 200) + ' 200w, ' + sized(p.s, 400) + ' 400w, ' + sized(p.s, 600) + ' 600w');
      }
      a.appendChild(box);
      var nm = doc.createElement('span');
      nm.className = 'swt-dprod__name';
      nm.textContent = p.n;
      a.appendChild(nm);
      var pr = doc.createElement('span');
      pr.className = 'swt-dprod__price';
      pr.innerHTML = p.p;
      a.appendChild(pr);
      return a;
    }
    function topFill(box) {
      if (box.hasAttribute('data-top-done')) return;
      box.setAttribute('data-top-done', '');
      var grid = box.querySelector('[data-top-grid]');
      var max = parseInt(box.getAttribute('data-top-n'), 10) || 4;
      topLoad(box).then(function (list) {
        list = (list || []).slice(0, max);
        if (!list.length || !grid) { box.hidden = true; return; }
        var frag = doc.createDocumentFragment();
        list.forEach(function (p, i) { frag.appendChild(topCard(p, i)); });
        grid.textContent = '';
        grid.appendChild(frag);
        void grid.offsetWidth;
        requestAnimationFrame(function () {
          grid.querySelectorAll('.swt-dprod.is-new').forEach(function (a) { a.classList.remove('is-new'); });
        });
      }).catch(function () { box.hidden = true; });
    }

    function wake(view) {
      if (!view || view.hasAttribute('data-swt-woke')) return;
      view.setAttribute('data-swt-woke', '');
      view.querySelectorAll('img[data-src]').forEach(function (img) {
        var src = img.getAttribute('data-src'), set = img.getAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        showImg(img, src, set);
      });
      view.querySelectorAll('[data-feed]').forEach(fillFromFeed);
      view.querySelectorAll('[data-top-feed]').forEach(topFill);
    }

    /* floating app widgets (chat, wishlist tab, badges) sit above the sheet:
       hide any fixed element outside the header while the menu is open */
    var floaters = [];
    function hideFloaters() {
      var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function (n) {
          if (n === section) return NodeFilter.FILTER_REJECT;
          var d = 0, p = n;
          while (p && p !== doc.body) { d++; p = p.parentElement; }
          return d > 4 ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }
      });
      var n;
      while ((n = walker.nextNode())) {
        var cs = getComputedStyle(n);
        if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.display === 'none' || (parseInt(cs.zIndex, 10) || 0) < 0) continue;
        floaters.push([n, n.style.getPropertyValue('visibility'), n.style.getPropertyPriority('visibility')]);
        n.style.setProperty('visibility', 'hidden', 'important');
      }
    }
    function showFloaters() {
      floaters.forEach(function (f) {
        if (f[1]) f[0].style.setProperty('visibility', f[1], f[2]); else f[0].style.removeProperty('visibility');
      });
      floaters = [];
    }

    function focusSoon(el) {
      if (el) setTimeout(function () { el.focus({ preventScroll: true }); }, 60);
    }

    function setView(next, back) {
      if (!next || next === current) return;
      if (!back) wake(next);
      var prev = current;
      prev.classList.remove('is-active');
      prev.setAttribute('inert', '');
      if (back) prev.classList.remove('is-behind'); else prev.classList.add('is-behind');
      next.classList.remove('is-behind');
      next.removeAttribute('inert');
      next.scrollTop = 0;
      next.classList.add('is-active');
      current = next;
      var sub = back ? prev : next;
      var trig = rootView.querySelector('[data-swt-go="' + sub.id + '"]');
      if (trig) trig.setAttribute('aria-expanded', back ? 'false' : 'true');
      focusSoon(back ? trig : next.querySelector('[data-swt-back]'));
    }

    function reset() {
      views.forEach(function (v) {
        v.classList.remove('is-active', 'is-behind');
        if (v !== rootView) v.setAttribute('inert', '');
      });
      rootView.classList.add('is-active');
      rootView.removeAttribute('inert');
      current = rootView;
      drawer.querySelectorAll('[data-swt-go]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    function open() {
      clearTimeout(hideT);
      if (ctx.closeMenu) ctx.closeMenu();
      lastFocus = doc.activeElement;
      drawer.hidden = false;
      if (usePop) {
        try { if (!drawer.matches(':popover-open')) drawer.showPopover(); }
        catch (e) { usePop = false; drawer.classList.add('is-top'); }
      }
      void drawer.offsetHeight;
      drawer.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      doc.documentElement.classList.add('swt-lock');
      if (!usePop && !floaters.length) hideFloaters();
      settleT = setTimeout(function () { drawer.classList.add('is-settled'); }, 700);
      focusSoon(sheet);
      /* best sellers: start the fetch now so the cards are ready on tap */
      tops.forEach(function (b) { if (!b.hasAttribute('data-top-done')) topLoad(b).catch(function () {}); });
    }

    function close() {
      if (drawer.hidden) return;
      clearTimeout(settleT);
      drawer.classList.remove('is-open', 'is-settled', 'is-dragging');
      sheet.style.transform = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      doc.documentElement.classList.remove('swt-lock');
      hideT = setTimeout(function () {
        if (usePop) { try { drawer.hidePopover(); } catch (e) {} }
        drawer.hidden = true; reset(); showFloaters();
      }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    ctx.drawer.open = open;
    ctx.drawer.close = close;

    if (openBtn) openBtn.addEventListener('click', open, sig);
    drawer.querySelectorAll('[data-swt-drawer-close]').forEach(function (b) { b.addEventListener('click', close, sig); });

    drawer.addEventListener('click', function (e) {
      var go = e.target.closest('[data-swt-go]');
      if (go) { setView(doc.getElementById(go.getAttribute('data-swt-go')), false); return; }
      if (e.target.closest('[data-swt-back]')) setView(rootView, true);
    }, sig);

    /* keep Tab inside the open sheet */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button:not([disabled])'), function (el) {
        return !el.closest('[inert]') && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || a === sheet)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }, sig);

    /* drag the handle down to close */
    var startY = 0, dy = 0, t0 = 0, dragging = false;
    if (grab) {
      grab.addEventListener('touchstart', function (e) {
        if (e.target.closest('[data-swt-drawer-close]')) return;
        dragging = true; dy = 0; t0 = Date.now();
        startY = e.touches[0].clientY;
        drawer.classList.add('is-dragging');
      }, { passive: true, signal: sig.signal });
      grab.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true, signal: sig.signal });
      grab.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        drawer.classList.remove('is-dragging');
        sheet.style.transform = '';
        if (dy > 110 || (dy > 40 && Date.now() - t0 < 250)) close();
      }, sig);
    }

    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) { if (e.matches) close(); }, sig);

    return function () {
      clearTimeout(hideT); clearTimeout(settleT);
      if (usePop) { try { drawer.hidePopover(); } catch (e) {} }
      doc.documentElement.classList.remove('swt-lock');
      showFloaters();
    };
  });
})();
